module.exports = __webpack_public_path__ + "static/media/tela-inicial.db26515a.png";